(function ( $ ) {

    function blockUI(){
        $('body').attr('id','cb-block-ui');
    }

    function UnblockUI(){
        $('body').attr('id','');
    }


    window.addEventListener('load', function(){
        FlagsToItems();
    });

    $('body').on('adding_to_cart',function(){
        blockUI();

    });

    $('body').on('update_checkout',function(){
        blockUI();

    });

    $('body').on('checkout_error',function(){
        UnblockUI();

    });

    $(document).on('DOMNodeInserted', function(e) {
        if ( $(e.target).hasClass('woocommerce-error') ) {
            UnblockUI();    
         }
       });


    $('body').on('updated_checkout',function(){
        UnblockUI();

    });


    $('body').on('removing_from_cart',function(){
        blockUI();
    });


    $('body').on('ui_updated',function(){
        UnblockUI();
    });

    $(document).on('click', '#place_order', function(){
        blockUI();
    });


    $('body').on('added_to_cart',function(event, fragments, cart_hash, button){
        FlagsToItems();
        updateCartFragment();
        $('body').trigger('ui_updated');
        var product_id    = button.data('product_id'),   // Get the product id
        product_qty   = button.data('quantity'),     // Get the quantity
        product_name  = button.data('product_name'), // Get the product name
        product_price = button.data('product_price'), // Get the product price
        product_thumb = button.data('product_thumb'); // Get the product price

        setTimeout(floating_cart, 500, product_name, product_price, product_qty);
        

    });

    $(document).on('click', '.remove-product', function(){
        $('body').trigger('removing_from_cart');
        var product_id = jQuery(this).attr("data-product_id");
        setTimeout(removeProduct, 10, product_id);
        
    });

    function removeProduct(product_id){
        removeFromCartById(product_id);
        FlagsToItems();
        updateCartFragment(); 
        $('body').trigger('ui_updated');
    }

    $('#close-floating-cart').on('click', function(){
        closeFloatingCart();
    })


    function updateCartFragment(){
        var items = getCartItems();
        //console.log(items);

        if(Object.keys(items).length > 0){
            var q = 0;
            $('.cart-icon').removeClass('empty');
            $('.cart-icon').addClass('not-empty');
            

            $.each(items, function(key, item){
                q += item.quantity;
            });

            $('#cart-content-header').html(q);

        }else{
            $('#cart-content-header').html(Object.keys(items).length);
            $('.cart-icon').addClass('empty');
            $('.cart-icon').removeClass('not-empty');
        }

        
    }

    function floating_cart(product_name, product_price, product_qty){
        $('#floating-cart').addClass('show');
        $('#floating-cart #product_name').html(product_name);
        $('#floating-cart #product_qty').html(product_qty);
        $('#floating-cart #product_price').html(formatPrice(product_price));
        setTimeout(closeFloatingCart, 3000);
    }

    function closeFloatingCart(){
        $('#floating-cart').removeClass('show');
    }

    function FlagsToItems(){
        
        $('.add-to-cart-system').addClass('no-product-in-cart');
        $('.cart-quantity-item').html('0');

        var items = getCartItems();


        $.each(items, function(key, item){
            $('#cart-quantity-' + item.product_id).html(item.quantity);
            $('#add-to-cart-system-' + item.product_id).removeClass('no-product-in-cart');
        });


    }

    


    //ajax functions

    function getCartItems(){

        var cart_data = $.ajax({
            type: 'POST',
            url: main_script.ajaxurl,
            data: {
                action: 'get_cart_items',
            },
            //dataType: 'html',
            context: document.body,
            global: false,
            async:false,

            success: function(data){
                return data;
            }
        }).responseJSON;

        return cart_data.data;

    }



    function removeFromCartById(id){

        var removed = $.ajax({
            type: 'POST',
            url: main_script.ajaxurl,
            data: {
                action : 'remove_item_from_cart',
                'product_id' : id,
                'product_quantity' : $('#cart-quantity-'+id).html(),
            },
            context: document.body,
            global: false,
            async:false,
            
            success: function(data){
                $('body').trigger('removed_from_cart');
                return data;
            }
        });

    }


    function formatPrice(number){
        var n = parseFloat(number);
        return n + ' €';
    }




})( jQuery );